import PropTypes from "prop-types";

export default function BTextareaField({
  fieldName,
  placeholder,
  register,
  validation,
  type = "text",
  step = "1",
  cols,
  rows,
}) {
  return (
    <div>
      <textarea
        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
        type={type}
        cols={cols}
        rows={rows}
        placeholder={placeholder}
        step={step}
        {...register(fieldName, { ...validation })}
      ></textarea>
    </div>
  );
}

BTextareaField.propTypes = {
  fieldName: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  validation: PropTypes.object,
  type: PropTypes.string,
  register: PropTypes.func.isRequired,
};
